export default __webpack_public_path__ + "static/media/laptop.c0a5a0d1.png";